module.exports = __webpack_public_path__ + "static/img/bgi-login.3133e256.png";